<div class="tooltip" [style.left.px]="left" [style.bottom.px]="bottom">
  <ng-container *ngIf="template; else tooltipRef">
    <ng-template [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ tooltip }"></ng-template>
  </ng-container>

  <ng-template #tooltipRef>
    <span>{{tooltip}}</span>
  </ng-template>
</div>
